<div class="flex items-center max-w-sm">
  <select
    [(ngModel)]="selectedNwNumberMajorPart"
    (change)="onNwNumberMajorSelect($event)"
    class="text-sm rounded-s-lg border block p-2.5 min-w-28 bg-amazone-gray placeholder-gray-400 text-white font-medium focus:ring-amazone-orange focus:border-amazone-orange cursor-pointer"
  >
    @for (major of nwNumberMajors; track $index) {
      <option value="{{ major.nwNumberWithMajorRelease }}">{{ major.nwNumberWithMajorRelease }}</option>
    }
  </select>
  <select
    [(ngModel)]="selectedSwPartNumberId"
    (change)="onMinorSelect($event)"
    class="text-sm rounded-e-lg border block p-2.5 min-w-21 bg-amazone-gray placeholder-gray-400 text-white font-medium focus:ring-amazone-orange focus:border-amazone-orange cursor-pointer"
  >
    @for (minorPart of minorParts; track $index) {
      <option value="{{ minorPart.swPartNumberId }}">
        {{ commonUtils.maskSwPartNumberMinorRelease(minorPart.minorRelease) }}
        {{ commonUtils.swPartNumberStateToSymbol(minorPart.state) }}
      </option>
    }
  </select>
</div>
